export const POST_VIEW = 'PostView';
export const MKT_ANSWER_SUBMIT = 'MKTAnswerSubmit';
export const MKT_START = 'MKTStart';
export const MKT_SEE_RESULT = 'MKTSeeResult';
export const MKT_LOGIN = 'MKTLogin';
export const MKT_SIGNUP = 'MKTSignup';
export const MKT_SHARE_FB = 'MKTShareFB';
export const MKT_RESULT_ANSWER = 'MKTResultAnswer';
export const QUIZ_SUBMIT = 'QUIZ_SUBMIT';
export const CLICK_SIGNUP_IN_ARTICLE = 'CLICK_SIGNUP_IN_ARTICLE';
export const CLICK_SIGNIN_IN_ARTICLE = 'CLICK_SIGNIN_IN_ARTICLE';
export const STUDENT_START_PRACTICE = 'STUDENT_START_PRACTICE';
export const STUDENT_CHECK_ANSWER = 'STUDENT_CHECK_ANSWER';
export const STUDENT_START_NEW_ROUND = 'STUDENT_START_NEW_ROUND';
export const HOME_DOWNLOAD_CLICK = 'HOME_DOWNLOAD_CLICK';

// instructor-profile
export const NAV_COURSE_ALL_INSTRUCTOR_CLICK =
  'NAV_COURSE_ALL_INSTRUCTOR_CLICK';
export const NAV_RC_ALL_INSTRUCTOR_CLICK = 'NAV_RC_ALL_INSTRUCTOR_CLICK';



// WEBPACK FOOTER //
// ./app/constants/gtmEvents.js